import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface PageScrollState {
    readonly size: number;
    readonly scrollPosition: number;
}

interface PagesStateStore {
    readonly pages: Record<string, PageScrollState>;
    getPageState: (pageKey: string) => PageScrollState;
    setPageState: (pageKey: string, state: PageScrollState) => void;
    resetPageState: (pageKey: string) => void;
}

const DEFAULT_PAGE_STATE: PageScrollState = {
    size: 1,
    scrollPosition: 0,
};

export const usePagesStateStore = create<PagesStateStore>()(
    persist(
        (set, get) => ({
            pages: {},

            getPageState: (pageKey) => {
                return get().pages[pageKey] ?? DEFAULT_PAGE_STATE;
            },

            setPageState: (pageKey, state) => {
                set((prev) => ({
                    pages: {
                        ...prev.pages,
                        [pageKey]: state,
                    },
                }));
            },

            resetPageState: (pageKey) => {
                set((prev) => ({
                    pages: {
                        ...prev.pages,
                        [pageKey]: DEFAULT_PAGE_STATE,
                    },
                }));
            },
        }),
        {
            name: 'pages-state',
            storage: createJSONStorage(() => sessionStorage),
            partialize: (state) => ({ pages: state.pages }),
        },
    ),
);
